module.exports = __webpack_public_path__ + "img/epr-article-top-img_medium.bcaa5752.webp";